var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#62727A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6736 5.33594H37.3369V47.9992H42.6736V5.33594Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8869 32L46.6687 34.5725L30.1139 61.3367L25.332 58.7541L41.8869 32Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 45.3375C42.9472 45.3375 45.3365 42.9481 45.3365 40.0008C45.3365 37.0534 42.9472 34.6641 39.9998 34.6641C37.0524 34.6641 34.6631 37.0534 34.6631 40.0008C34.6631 42.9481 37.0524 45.3375 39.9998 45.3375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 44.0062C42.2121 44.0062 44.0052 42.2131 44.0052 40.0011C44.0052 37.7892 42.2121 35.9961 40.0002 35.9961C37.7882 35.9961 35.9951 37.7892 35.9951 40.0011C35.9951 42.2131 37.7882 44.0062 40.0002 44.0062Z",
    fill: "#62727A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9797639c13110a82089cffd5981a1289.svg";
export { ForwardRef as ReactComponent };